import { h, Component } from 'preact';
import { connect } from 'react-redux';
import reduce from '../reducers';
import * as actions from '../actions';
import designService from '../service/designService';
import constants from '../constants';
import { createPortal } from 'preact/compat';

export default @connect(reduce, actions)
class DuplicatedNameModal extends Component {
  constructor() {
    super();

    this.state = {
      name: '',
      error: ''
    };

    this.onChangeDesignName = (event) => {
      this.setState({ name: event.target.value });
      if (event.keyCode === constants.ENTER_KEY) {
        event.preventDefault();
        event.stopPropagation();
        this.save();
      }
    };

    this.save = () => {
      if (!this.state.name.trim()) {
        return;
      }

      this.props.markAsModified();

      this.props.setIsSaved(false);
      this.props.setIsSaving(true);

      designService.updateDesign({
        id: this.props.designId,
        name: this.state.name,
      })
        .then((resp) => {
          this.props.setIsSaved(true);
          this.props.setIsSaving(false);

          if (resp.data.success) {
            if (resp.data.message === 'DUPLICATED_NAME') {
              this.setState({ error: 'Duplicated design name. Please choose another name.' });
              window.setTimeout(() => this.setState({ error: '' }), 2000);
            } else {
              this.props.setDesignName(this.state.name);
              this.setState({
                name: '',
                error: ''
              });
              this.props.onModalClose();
            }
          }
        });
    };
  }

  render(props, state) {
    return props.open ? createPortal(<div>
      <div className="modal-back" onClick={props.onModalClose}/>
      <div className="modal save-modal">
        <header>
          <h2>Duplicated design name</h2>
        </header>
        <div className="content">
          <p>
            You already have a design called <b>{props.designName}</b>.<br/>
            Please choose another name.
          </p>

          <div className="form-block">
            <input type="text" placeholder="Design name..." value={state.name} onKeyUp={this.onChangeDesignName}/>
          </div>

          <p style={{
            color: '#f9605b',
            fontSize: '13px'
          }}>{state.error}</p>

          <footer>
            <a className={'btn primary ' + (state.name.trim() === '' ? 'disabled' : '')} onClick={this.save}>Save</a>
          </footer>
        </div>
      </div>
    </div>, document.getElementById('modals')) : null;
  }
}
